import { render, staticRenderFns } from "./textBookReader.vue?vue&type=template&id=76f4fc79&"
import script from "./textBookReader.vue?vue&type=script&lang=js&"
export * from "./textBookReader.vue?vue&type=script&lang=js&"
import style0 from "./textBookReader.vue?vue&type=style&index=0&id=76f4fc79&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports